import React, { forwardRef, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'

registerLocale('pt-BR', ptBR)

export const ModalRangeDatePicker = forwardRef(
  (
    { isOpen, onClose, setInputValue, setSelectedRange, selectedRange },
    ref,
  ) => {
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(new Date())

    const handleStartDateChange = (date) => {
      setStartDate(date)
    }

    const handleEndDateChange = (date) => {
      setEndDate(date)
    }

    const handleDateRangeSelect = () => {
      setSelectedRange({ startDate, endDate })

      setInputValue(
        startDate && endDate
          ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
          : '',
      )

      onClose()
    }

    return (
      <Modal
        as="div"
        ref={ref}
        show={isOpen}
        onHide={onClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Selecione o Intervalo de Datas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Data Inicial</Form.Label>

            <DatePicker
              selected={startDate || selectedRange?.startDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Data Final</Form.Label>
            <DatePicker
              selected={endDate || selectedRange?.endDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onClose}
          >
            Fechar
          </Button>
          <Button
            variant="primary"
            onClick={handleDateRangeSelect}
          >
            Selecionar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  },
)
